export default `
/** metronic theme style override */
.dropdown.show .dropdown-menu{
  display: block;
} 

.topbar-item {
  height: 100%;
}

.card-header .btn{  
      padding: .65rem 1rem !important;  
}

.card-header .btn-sm{  
  padding: .55rem 0.75rem !important;  
}

.hidden{
  display:none;
}
`;
